<template>
    <main class="main">
        <div class="container">
            <div class="row">
                <side-menu />
                <div class="content main__content col-xs-9 col-sm-9">
                    <router-link to="/">Home</router-link> |
                    <router-link to="/about">About</router-link>
                    <router-view />
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import SideMenu from '@/views/layouts/SideMenu';

export default {
  name: 'CapMainLogged',
  components: {
    'side-menu': SideMenu,
  },
};
</script>

<style scoped>

</style>
